/* Keep the page-content offset in sync with the fixed header's REAL height.
   The header is position:fixed, and its height differs by breakpoint (and can
   change with content), so a single CSS value leaves a gap or overlap. We
   measure the header and expose it as --cg-header-h, which #xo-main-content
   uses for its top padding. */
(function () {
  const header = document.querySelector('.shopify-section.section-header');
  if (!header) return;

  const sync = () => {
    const h = header.offsetHeight;
    // Guard against a 0 measurement (header not yet laid out): keep the CSS
    // fallback instead of pinning the mega/content to the top.
    if (h > 0) {
      document.documentElement.style.setProperty('--cg-header-h', h + 'px');
    }
  };

  sync();
  if (window.ResizeObserver) {
    new ResizeObserver(sync).observe(header);
  }
  window.addEventListener('load', sync);
  window.addEventListener('resize', sync);
})();
